import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getQueryParams = useCallback(() => {
    const result: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }, [searchParams]);

  const addQueryParams = (params: Record<string, string | undefined>) => {
    const oldParams = getQueryParams();

    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value) {
        oldParams[key] = value;
      } else {
        delete oldParams[key];
      }
    });

    const newSearchParams = new URLSearchParams();
    for (const key in oldParams) {
      newSearchParams.set(key, oldParams[key]);
    }
    setSearchParams(newSearchParams, { replace: true });
  };

  return { getQueryParams, addQueryParams };
};
